import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './ChartItemLabel.module.css'

function ChartItemLabel({ className = styles.label, text }) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <FloatingTooltip content={text} disabled={!overflow}>
      <Text isSecondary className={className} ref={setContentOverflowRef}>
        {text}
      </Text>
    </FloatingTooltip>
  )
}

export default ChartItemLabel
